import moment from 'moment'
import { ETERNAL_PROMO_CODE_DAY } from '../../shared-lib/commonStrings'
import I18n from '../../shared-lib/i18n/i18n'
import { DiscountType, RedeemableBy } from '../../graphQL/generated/enums'
import { invertObject } from './utils'
import { couponColors } from '../../shared-solo/stores/ExternalPromocodeStore/ExternalPromocodeModel'

export function getDiscountTextForPromocode(data: { discountAmount?: number | undefined, discountType?: string | undefined }, i18n: I18n) {
  const { discountType, discountAmount } = data

  if (discountType === 'monies') {
    return `${i18n.currencyFormat(discountAmount || 0)} off`
  } else {
    return `${discountAmount}% off`
  }
}

export function generateCouponColorForPromocode(data: ExternalPromocode) {
  if (!data.code) return 'green'

  const index = data.code.charCodeAt(0) % couponColors.length
  return couponColors[index] || 'green'
}

export const expiryTextTemplates = {
  noExpiration: '**$0**',
  expiring: 'Expires in **$0 $1**',
  expired: 'Expired on **$0**',
}

export const expiryTextTemplatesRegular = {
  noExpiration: '$0',
  expiring: 'Expires in $0 $1',
  expired: 'Expired on $0',
}

export function getExpiryTextForDate(expiryDate: Date, i18n: I18n, templates = expiryTextTemplates) {
  const { s, pluralise } = i18n

  let expiryText = ''
  const diff = moment(expiryDate).diff(moment(), 'days')

  if (moment(expiryDate).startOf('day').toISOString() === moment(ETERNAL_PROMO_CODE_DAY).startOf('day').toISOString()) {
    return s(templates.noExpiration, 'No expiry')
  }

  if (diff > 0) {
    expiryText = s(templates.expiring, diff, pluralise('day', diff))
  } else {
    expiryText = s(templates.expired, moment(expiryDate).format('Do MMM'))
  }

  return expiryText
}

const displayValues = {
  'New clients only': RedeemableBy.NewClients,
  'Existing clients only': RedeemableBy.ExistingClients,
  'Anyone': RedeemableBy.Anyone,
  'Specific clients': RedeemableBy.Custom,
  'Amount': DiscountType.Monies,
  'Percentage': DiscountType.Percent,
}

export const invertedDisplayValues = invertObject(displayValues) as Record<string, string>

export interface $PromocodeData {
  code: string
  redeemableBy: RedeemableBy
  discountType: DiscountType
  discountAmount: number
  expiryDate: null | Date
  treatmentIds: Array<string>
  customRedeemableExternalClientIds: Array<string>
  active: boolean
  applyToAllTreatments: boolean
  applyToAllClients: boolean
  maxRedemptions?: number,
  label: string
}

export enum PromoCodeSteps {
  label = 'PromoCodeLabel',
  code = 'PromoCodeCode',
  clients = 'PromoCodeClients',
  treatments = 'PromoCodeTreatments',
  maxRedemptions = 'PromoCodeMaxRedemptions',
  discount = 'PromoCodeDiscount',
  expiry = 'PromoCodeExpiry',
}

export enum PromoCodeRedemptions {
  unlimited = 'Unlimited',
  limited = 'Up to a specific limit',
}

export enum PromoCodeExpiryOptions {
  noExpiry = 'No expiry date',
  specificDate = 'Expires after a specific date',
}

export enum treatmentOptions {
  allTreatments = 'All Treatments',
  specificTreatments = 'Specific Treatments',
}

